import { CmsEvents as CmsEventsLayout } from '../../../components/BuyGuide';

export function CmsEvents() {
  return <CmsEventsLayout />;
}
